import { ANNOUNCEMENT_COOLDOWN_MINUTES, ANNOUNCEMENTS_PER_ROOM } from '@pulsify/shared/dto'
import { LiveRoomErrorCode } from '@pulsify/shared/errors'
import { NetworkError } from '@pulsify/shared/network-error'
import * as m from '~/paraglide/messages'
import { getErrorMessageFromError } from '~/shared/lib/api-errors'

function retryAfterMinutes(details: unknown): number {
  if (typeof details === 'object' && details !== null && 'retryAfterMinutes' in details) {
    const minutes = (details as { retryAfterMinutes: unknown }).retryAfterMinutes
    if (typeof minutes === 'number' && minutes > 0) return minutes
  }
  return ANNOUNCEMENT_COOLDOWN_MINUTES
}

export function announcementErrorMessage(error: unknown): string {
  if (error instanceof NetworkError) {
    switch (error.code) {
      case LiveRoomErrorCode.AnnouncementTooSoon:
        return m.roomAnnouncementTooSoon({ minutes: retryAfterMinutes(error.details) })
      case LiveRoomErrorCode.AnnouncementLimit:
        return m.roomAnnouncementLimit({ count: ANNOUNCEMENTS_PER_ROOM })
      case LiveRoomErrorCode.NoVenueRoom:
      case LiveRoomErrorCode.Closed:
      case LiveRoomErrorCode.NotOpenYet:
        return m.roomAnnouncementNoRoom()
    }
  }
  return getErrorMessageFromError(error)
}
